package com.pincer.core.multiplatform

import com.pincer.core.Logger
import kotlin.js.console

actual fun mpName() = "JS"

actual fun mpLog(line: String) = console.log(line)

// jsSHA from npm (it used to be pasted into pincerlibs.js, copied into each web module)
@JsModule("jssha")
@JsNonModule
private external class jsSHA(variant: String, inputFormat: String, options: dynamic) {
    fun update(input: String)
    fun getHash(format: String): String
}

actual fun mpHmacSha256B64Url(string: String, secret: String): String {
    val hmacKey: dynamic = js("({})")
    hmacKey.value = secret
    hmacKey.format = "TEXT"
    val options: dynamic = js("({})")
    options.hmacKey = hmacKey
    val sha = jsSHA("SHA-256", "TEXT", options)
    sha.update(string)
    return sha.getHash("B64").replace("+", "-").replace("/", "_").replace("=", "")
}
